<template>
  <div>
    <Breadcrumbs :items="breadcrumbs" />

    <rp-op-upload-form
      v-model="resource"
      :showHospital="false"
      :showLocale="false"
      :operationTypes="operationTypes"
      @submit="uploadCsv"
    />

    <div class="csvwarning">
      ATTENTION NEW CSV FORMAT, PLEASE DOWNLOAD THE NEW EXCEL TEMPLATE TO USE THE UP TO DATE VERSION
    </div>

    <div class="buttonrow">
      <a :href="template">
        <rp-button>
          <rp-sprite class="button-icon" name="csv_icon" />
          Download Excel Template
        </rp-button>
      </a>
      <a href="https://youtu.be/fVzq78Yxm2c" target="_blank">
        <rp-button>
          <rp-sprite class="button-icon" name="learn_icon" />
          See How This Works
        </rp-button>
      </a>
    </div>

    <div class="output">
      <h3 v-if="result && result.data && result.data.errors">Error Log:</h3>
      <ul>
        <li v-for="line in logLines" :key="line">
          {{line}}
        </li>
      </ul>
    </div>

    <rp-overlay :active="showConfirmationDialog">
      <rp-alert
        icon="raypro_icon"
        message="CSV uploaded succesfully"
        :onClick="closeConfirmationDialog"
      />
    </rp-overlay>

    <rp-overlay :active="showUploadErrorDialog">
      <rp-alert
        class="error-icon"
        icon="warning_rounded"
        message="CSV upload failed - please scroll down to review the error report"
        :onClick="closeUploadErrorDialog"
      />
    </rp-overlay>

    <rp-overlay :active="showSpinner">
      <rp-spinner />
    </rp-overlay>

  </div>
</template>

<script>
import page from '@/mixins/page'
import {mapGetters} from 'vuex'

import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Breadcrumbs from '@/components/Breadcrumbs'
import Button from 'raypro_ui/src/components/ui/inputs/Button'
import Sprite from 'raypro_ui/src/components/ui/Sprite'
import Alert from 'raypro_ui/src/components/ui/Alert'
import Spinner from 'raypro_ui/src/components/ui/Spinner'
import OperationUploadForm from 'raypro_ui/src/components/ui/forms/OperationUpload'
import { getUserHospitals } from 'raypro_ui/src/api/users'
import { getLocales } from 'raypro_ui/src/api/locales'
import { adminUploadOperationsCsv, getOperationTypes } from 'raypro_ui/src/api/operations'

const TEMPLATES_ROOT = runtimeconfig.TEMPLATES_ROOT || process.env.TEMPLATES_ROOT

export default {
  mixins: [page],

  components: {
    'rp-button': Button,
    'rp-overlay': Overlay,
    'rp-sprite': Sprite,
    'rp-alert': Alert,
    'rp-spinner': Spinner,
    'rp-op-upload-form': OperationUploadForm,
    Breadcrumbs,
  },

  data() {
    return {
      title: 'Upload Surgeries CSV',
      breadcrumbs: [{label: 'Upload Surgeries CSV'}],
      showConfirmationDialog: false,
      showUploadErrorDialog: false,
      showSpinner: false,
      result: null,
      operationTypes: [],
      resource: {file: null, operation_type_id: ''},
      template: TEMPLATES_ROOT + "templ_op_adm.xlsm"
    }
  },

  mounted() {
    this.getHospitals()
    this.getLocales()
    this.getOperationTypes();
  },

  computed: {
    ...mapGetters(['authUser']),

    logLines: function() {
      if (this.result && this.result.data) {
        if (this.result.data.message) {
          return [this.result.data.message]
        } else if (this.result.data.errors) {
          return this.result.data.errors
        }
      }
      return [];
    },
  },

  methods: {
    closeConfirmationDialog() {
      this.showConfirmationDialog = false
    },

    closeUploadErrorDialog() {
      this.showUploadErrorDialog = false
    },

    getHospitals() {
      getUserHospitals({id: this.authUser.id}).then(({data}) => {
        this.hospitals = data
        this.resource.hospital_id = (data.length > 0) ? data[0].id : ''
      })
      .catch(() => {
      })
    },

    getLocales() {
      getLocales().then(({data}) => {
        this.locales = data;
        this.resource.locale_id = (data.length > 0) ? data.find(x => x.code == 'en-GB').id : ''
      })
      .catch(() => {
      })
    },

    getOperationTypes() {
      getOperationTypes().then(({data}) => {
        this.operationTypes = data;
        this.resource.operation_type_id = (data.length > 0) ? data[0].id : ''
      })
      .catch(() => {
      })
    },

    uploadCsv() {
      this.showSpinner = true
      const formData = new FormData()
      formData.append('file', this.resource.file)
      formData.append('operation_type_id', this.resource.operation_type_id)

      adminUploadOperationsCsv(formData)
      .then(res => this.processResult(res))
      .finally(() => this.showSpinner = false)
    },

    processResult(result) {
      this.result = result
      if (result.data.message) {
        this.showConfirmationDialog = true
      } else if (result.data.errors) {
        this.showUploadErrorDialog = true
      }
    },
  }
}
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/main.sass'
  @import '../../../stylesheets/helpers/mixins'

  .output
    li
      font-size: larger

  .csvwarning
    margin: 20px
    max-width: 550px
    color: red
    font-size: larger
    text-align: center

  .buttonrow
    margin: 20px
    max-width: 550px
    display: flex
    justify-content: space-evenly

    button
      width: 150px
      height: 55px
      padding: 0px
      font-size: 12px
      color: $color-text
      background-color: $color-panel-bg
      border-color: $color-border-lighter

    .button-icon
      width: 35px
      height: 35px
      stroke: #000000
      stroke-width: 4px
      fill: transparent

</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/AdminOperationUpload.vue